import * as userResource from 'resources/user/hooks';
import * as companyResource from 'resources/company/hooks';

import * as userHelpers from 'resources/user/user.helpers';
import * as companyHelpers from 'resources/company/company.helpers';

const useCurrentUserPermissions = () => {
  const { data: user } = userResource.useCurrentUser();

  const { data: company } = companyResource.useCompany(
    user?.company_id,
    { enabled: !!user },
  );

  const isClient = userHelpers.isClient(user);
  const isRealtor = userHelpers.isRealtor(user);
  const isCoordinatorOrAdmin = userHelpers.isCoordinatorOrAdmin(user);
  const isCoordinator = userHelpers.isCoordinator(user);

  const isPersonal = companyHelpers.isPersonal(company);
  const isCorporate = companyHelpers.isCorporate(company);

  const isPersonalRealtor = isRealtor && isPersonal;
  const isCorporateRealtor = isRealtor && isCorporate;

  const hasAdminPermissions = !isClient && (isPersonalRealtor || isCoordinatorOrAdmin);

  return {
    hasAdminPermissions,
    isPersonalRealtor,
    isCorporateRealtor,
    isCoordinatorOrAdmin,
    isCoordinator,
  };
};

export default useCurrentUserPermissions;
